import { Badge, Button, Table } from 'react-bootstrap';
import './MercurXBackofficeUserTable.scss';
import { connect } from 'react-redux';
import MercurXIcons from '../MercurXIcons/MercurXIcons';
import { mainColors } from '../../helpers/colors';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Swal from 'sweetalert2';
import useMercurxPagination from '../../hooks/useMercurxPagination';
import MercurXTablePagination from '../MercurXTablePagination/MercurXTablePagination';
import MercurXSortableHeader from '../MercurXSortableHeader/MercurXSortableHeader';
import {
  resendBackofficeActivationEmailActionRequest,
  setBackofficeUsersSortDataAction,
  sortBackofficeUsersAction,
} from '../../store/backofficeUser/backofficeUserActions';
import {
  BACKOFFICEUSERS_SORT_KEYS,
  BACKOFFICEUSERS_SORT_TYPES,
} from '../../pages/BackofficeUsers/backofficeUsersConstants';

function MercurXBackofficeUserTable(props) {
  const {
    backofficeUsers,
    filteredBackofficeUsers,
    backofficeUsersSortData,
    setBackofficeUsersSortData,
    sortBackofficeUsers,
    resendBackofficeActivationEmailRequest,
  } = props;
  const history = useHistory();
  const sourceData = filteredBackofficeUsers || backofficeUsers || [];
  const {
    currentPage,
    totalPages,
    visiblePages,
    pagedData: renderedBackofficeUsers,
    rowOffset,
    isFirstPage,
    isLastPage,
    goToPage,
    goToFirstPage,
    goToPrevPage,
    goToNextPage,
    goToLastPage,
  } = useMercurxPagination(sourceData, 10, 5);

  function scrollToBackofficeUsersContainer() {
    const backofficeUsersContainer = document.getElementById('backofficeUsers-container');
    if (backofficeUsersContainer) {
      backofficeUsersContainer.scrollIntoView({ behavior: 'smooth' });
    }
  }

  const handlePageChange = (page) => {
    goToPage(page);
    scrollToBackofficeUsersContainer();
  };

  const handleFirstPage = () => {
    goToFirstPage();
    scrollToBackofficeUsersContainer();
  };

  const handlePrevPage = () => {
    goToPrevPage();
    scrollToBackofficeUsersContainer();
  };

  const handleNextPage = () => {
    goToNextPage();
    scrollToBackofficeUsersContainer();
  };

  const handleLastPage = () => {
    goToLastPage();
    scrollToBackofficeUsersContainer();
  };
  function editUser(backofficeUser) {
    history.push({
      pathname: '/backoffice-users/edit-user',
      state: {
        backofficeUser: backofficeUser,
      },
    });
  }

  const isUserActive = (backofficeUser) =>
    backofficeUser?.is_active?.toString().toLowerCase() === 'true';

  const formatLastActiveAt = (lastActiveAt) => {
    if (!lastActiveAt) {
      return 'No activity yet';
    }

    const parsedDate = new Date(lastActiveAt);
    if (Number.isNaN(parsedDate.getTime())) {
      return 'No activity yet';
    }

    const dateParts = new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).formatToParts(parsedDate);

    const datePartMap = dateParts.reduce((accumulator, part) => {
      accumulator[part.type] = part.value;
      return accumulator;
    }, {});

    const formattedDate = `${datePartMap.month}/${datePartMap.day}/${datePartMap.year}`;
    const formattedTime = `${datePartMap.hour}:${datePartMap.minute}`;

    return `${formattedDate} ${formattedTime}`;
  };

  const handleResendActivationEmail = (backofficeUser) => {
    Swal.fire({
      icon: 'question',
      title: 'Resend Activation Email?',
      text: `A new activation email will be sent to ${backofficeUser.email}.`,
      showCancelButton: true,
      confirmButtonColor: mainColors.primary,
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Resend Email',
    }).then((result) => {
      if (!result.isConfirmed) {
        return;
      }

      resendBackofficeActivationEmailRequest({
        userID: backofficeUser.id,
      });
      });
  };

  const handleSort = (sortKey, defaultSortType) => {
    const nextSortType = backofficeUsersSortData.sortKey === sortKey
      ? (backofficeUsersSortData.sortType === BACKOFFICEUSERS_SORT_TYPES.ASCENDING
        ? BACKOFFICEUSERS_SORT_TYPES.DESCENDING
        : BACKOFFICEUSERS_SORT_TYPES.ASCENDING)
      : defaultSortType;

    setBackofficeUsersSortData({
      sortKey,
      sortType: nextSortType,
    });
    sortBackofficeUsers();
  };

  const user = JSON.parse(localStorage.getItem('user'))?.user;
  return (
    <>
      <Table className="backofficeUsers-table-design" responsive hover borderless>
        <thead>
          <tr className="text-t-body-color text-fs-tag">
            <th>#</th>
            <th>
              <MercurXSortableHeader
                label="Full Name"
                isActive={backofficeUsersSortData.sortKey === BACKOFFICEUSERS_SORT_KEYS.FULL_NAME}
                isAscending={
                  backofficeUsersSortData.sortType === BACKOFFICEUSERS_SORT_TYPES.ASCENDING
                }
                onClick={() => handleSort(
                  BACKOFFICEUSERS_SORT_KEYS.FULL_NAME,
                  BACKOFFICEUSERS_SORT_TYPES.ASCENDING
                )}
              />
            </th>
            <th>
              <MercurXSortableHeader
                label="Email"
                isActive={backofficeUsersSortData.sortKey === BACKOFFICEUSERS_SORT_KEYS.EMAIL}
                isAscending={
                  backofficeUsersSortData.sortType === BACKOFFICEUSERS_SORT_TYPES.ASCENDING
                }
                onClick={() => handleSort(
                  BACKOFFICEUSERS_SORT_KEYS.EMAIL,
                  BACKOFFICEUSERS_SORT_TYPES.ASCENDING
                )}
              />
            </th>
            <th>
              <MercurXSortableHeader
                label="Super User"
                isActive={
                  backofficeUsersSortData.sortKey === BACKOFFICEUSERS_SORT_KEYS.SUPER_USER
                }
                isAscending={
                  backofficeUsersSortData.sortType === BACKOFFICEUSERS_SORT_TYPES.ASCENDING
                }
                onClick={() => handleSort(
                  BACKOFFICEUSERS_SORT_KEYS.SUPER_USER,
                  BACKOFFICEUSERS_SORT_TYPES.DESCENDING
                )}
              />
            </th>
            <th>
              <MercurXSortableHeader
                label="Developer"
                isActive={
                  backofficeUsersSortData.sortKey === BACKOFFICEUSERS_SORT_KEYS.DEVELOPER
                }
                isAscending={
                  backofficeUsersSortData.sortType === BACKOFFICEUSERS_SORT_TYPES.ASCENDING
                }
                onClick={() => handleSort(
                  BACKOFFICEUSERS_SORT_KEYS.DEVELOPER,
                  BACKOFFICEUSERS_SORT_TYPES.DESCENDING
                )}
              />
            </th>
            <th>
              <MercurXSortableHeader
                label="2FA Status"
                isActive={
                  backofficeUsersSortData.sortKey ===
                  BACKOFFICEUSERS_SORT_KEYS.TWO_FACTOR_STATUS
                }
                isAscending={
                  backofficeUsersSortData.sortType === BACKOFFICEUSERS_SORT_TYPES.ASCENDING
                }
                onClick={() => handleSort(
                  BACKOFFICEUSERS_SORT_KEYS.TWO_FACTOR_STATUS,
                  BACKOFFICEUSERS_SORT_TYPES.DESCENDING
                )}
              />
            </th>
            <th>
              <MercurXSortableHeader
                label="Last Active"
                isActive={
                  backofficeUsersSortData.sortKey === BACKOFFICEUSERS_SORT_KEYS.LAST_ACTIVE
                }
                isAscending={
                  backofficeUsersSortData.sortType === BACKOFFICEUSERS_SORT_TYPES.ASCENDING
                }
                onClick={() => handleSort(
                  BACKOFFICEUSERS_SORT_KEYS.LAST_ACTIVE,
                  BACKOFFICEUSERS_SORT_TYPES.DESCENDING
                )}
              />
            </th>
            <th>
              <MercurXSortableHeader
                label="Status"
                isActive={backofficeUsersSortData.sortKey === BACKOFFICEUSERS_SORT_KEYS.STATUS}
                isAscending={
                  backofficeUsersSortData.sortType === BACKOFFICEUSERS_SORT_TYPES.ASCENDING
                }
                onClick={() => handleSort(
                  BACKOFFICEUSERS_SORT_KEYS.STATUS,
                  BACKOFFICEUSERS_SORT_TYPES.DESCENDING
                )}
              />
            </th>
            {user?.is_superuser && <th>Actions</th>}
          </tr>
        </thead>
        {renderedBackofficeUsers?.length ? (
          <tbody>
            {renderedBackofficeUsers.map((item, index) => {
              const active = isUserActive(item);
              const formattedLastActive = formatLastActiveAt(item.last_active_at);

              return (
                <tr className="text-t-head-color" key={item.id || index}>
                  <td>{rowOffset + index + 1}</td>
                  <td>{item.full_name}</td>
                  <td>{item.email}</td>
                  <td>
                    {item.is_superuser ? (
                      <Badge bg="success">True</Badge>
                    ) : (
                      <Badge bg="danger">False</Badge>
                    )}
                  </td>
                  <td>
                    {item.is_developer ? (
                      <Badge bg="success">True</Badge>
                    ) : (
                      <Badge bg="danger">False</Badge>
                    )}
                  </td>
                  <td>
                    {item.two_factor_auth ? (
                      <Badge bg="success">Enabled</Badge>
                    ) : (
                      <Badge bg="secondary">Disabled</Badge>
                    )}
                  </td>
                  <td>
                    <span
                      className={
                        item.last_active_at ? 'user-last-active' : 'user-last-active-empty'
                      }
                    >
                      {formattedLastActive}
                    </span>
                  </td>
                  <td>
                    {item.is_active === 'True' ? (
                      <Badge bg="success">Active</Badge>
                    ) : item.is_active === 'False' ? (
                      <Badge bg="danger">Inactive</Badge>
                    ) : (
                      <Badge bg="info">Pending</Badge>
                    )}
                  </td>
                  {user?.is_superuser && (
                    <td>
                      <div className="user-table-actions">
                        <Button
                          size="sm"
                          variant="outline-secondary"
                          className="user-action-button"
                          onClick={() => editUser(item)}
                        >
                          <MercurXIcons
                            name="BsPencilSquare"
                            size={15}
                            color={mainColors.primary}
                          />
                          <span>Edit</span>
                        </Button>
                        <Button
                          size="sm"
                          variant="outline-primary"
                          className="user-action-button"
                          onClick={() => handleResendActivationEmail(item)}
                          disabled={active}
                          title={active ? 'Already active' : 'Resend activation email'}
                        >
                          Resend Mail
                        </Button>
                      </div>
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        ) : null}
      </Table>
      {!renderedBackofficeUsers?.length && (
        <div className="d-flex text-fs-body-md text-t-body-color justify-content-center">
          No backoffice user found according to search results.
        </div>
      )}
      <MercurXTablePagination
        currentPage={currentPage}
        totalPages={totalPages}
        visiblePages={visiblePages}
        isFirstPage={isFirstPage}
        isLastPage={isLastPage}
        onFirstPage={handleFirstPage}
        onPrevPage={handlePrevPage}
        onPageChange={handlePageChange}
        onNextPage={handleNextPage}
        onLastPage={handleLastPage}
      />
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    backofficeUsers: state.backofficeUserReducer.backofficeUsers,
    filteredBackofficeUsers: state.backofficeUserReducer.filteredBackofficeUsers,
    backofficeUsersSortData: state.backofficeUserReducer.backofficeUsersSortData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setBackofficeUsersSortData: (payload) => {
      dispatch(setBackofficeUsersSortDataAction(payload));
    },
    sortBackofficeUsers: () => {
      dispatch(sortBackofficeUsersAction());
    },
    resendBackofficeActivationEmailRequest: (payload) => {
      dispatch(resendBackofficeActivationEmailActionRequest(payload));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(MercurXBackofficeUserTable);
